const endpoints = {
  GET_PINCODE_DETAILS: '/v8/services/get_geolocation_coordinates',
  GET_MEDICAL_CONDITIONS: '/v8/services/get_medical_condition_group_list',
  SUBMIT_PATIENT_DETAILS: '/v8/services/generate_razorpay_payments_link',
  REQUEST_CALLBACK: '/v8/patient/request_callback_campaign_info',
  VERIFY_MEDICATION_CODE: '/v8/patient/verify_medication_code',
  GET_STATE_LIST: '/v8/patient/state_list',
  GET_CITY_LIST_BY_STATE_ID: '/v8/patient/city_list',

  // Get Doctor's City List
  GET_DOCTOR_CITY_LIST: '/v8/doctor/get_city_list',
  GET_HOSPITALS_IN_CITY_LIST: '/v8/doctor/get_hospital_in_city_list',
  GET_DOCTORS_LIST_IN_HOSPITAL_LIST: '/v8/doctor/get_doctor_in_hospital_list',
  ADD_DOCTOR: '/v8/doctor/add_doctor',
  ADD_HOSPITAL: '/v8/doctor/add_hospital',
  UPDATE_PATIENT_DOCTOR: '/v8/patient/update_patient_doctor',
}

export default endpoints
